<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-6">
                <b-card>
                    <div slot="header">
                        <i :class="[isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']"></i><strong> Soort belichting</strong>
                        <small>
                            <span v-if="isEditing">wijzigen</span>
                            <span v-else>toevoegen</span>
                        </small>
                    </div>
                    <form @submit.prevent="saveItem">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="col-form-label" for="naam">Naam <sup>*</sup></label>
                                <input type="text" v-model="model.naam" id="naam" name="naam" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('naam') }" />
                                <span class="small text-danger" v-show="errors.has('naam')">Naam is verplicht</span>
                            </div>
                        </div>
                    </div>
                    <div slot="footer">
                        <b-button type="submit" variant="primary">
                            <span>Opslaan</span>
                        </b-button>
                        <b-button type="button" @click="back" variant="secondary">Annuleren</b-button>
                    </div>
                    </form>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Form',
        props: ['model', 'isEditing'],
        methods: {
            saveItem () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$emit('save-item', this.model);
                    }
                });
            },
            back () {
                this.$router.go(-1);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/soortbelichting/Form.vue